import styled, { css } from 'styled-components';
export var GradientHighlightButtonSide;
(function (GradientHighlightButtonSide) {
    GradientHighlightButtonSide["TOP"] = "top";
    GradientHighlightButtonSide["BOTTOM"] = "bottom";
    GradientHighlightButtonSide["LEFT"] = "left";
    GradientHighlightButtonSide["RIGHT"] = "right";
})(GradientHighlightButtonSide || (GradientHighlightButtonSide = {}));
export const GradientHighlightButtonStyles = (props) => {
    let gradientDirection;
    let highlightBoundingSide;
    switch (props.side) {
        case GradientHighlightButtonSide.TOP:
        case GradientHighlightButtonSide.BOTTOM:
            gradientDirection = 'right';
            break;
        case GradientHighlightButtonSide.LEFT:
        case GradientHighlightButtonSide.RIGHT:
            gradientDirection = 'bottom';
            break;
    }
    switch (props.side) {
        case GradientHighlightButtonSide.TOP:
            highlightBoundingSide = 'bottom';
            break;
        case GradientHighlightButtonSide.BOTTOM:
            highlightBoundingSide = 'top';
            break;
        case GradientHighlightButtonSide.LEFT:
            highlightBoundingSide = 'right';
            break;
        case GradientHighlightButtonSide.RIGHT:
            highlightBoundingSide = 'left';
            break;
    }
    return css `
		position: relative;
		min-width: calc(${props.theme.sizing.lg} * 2);
		background-color: ${props.selected ? props.theme.primary : props.theme.palette.shade7};
		color: ${props.theme.palette.shade2};
		transition: border-bottom 0.2s linear;
		border: none;
		padding: ${props.theme.spacing.sm} ${props.theme.spacing.md};

		&:after {
			content: '';
			position: absolute;
			${props.side !== GradientHighlightButtonSide.TOP ? 'bottom: 0;' : ''}
			${props.side !== GradientHighlightButtonSide.BOTTOM ? 'top: 0;' : ''}
			${props.side !== GradientHighlightButtonSide.LEFT ? 'right: 0;' : ''}
			${props.side !== GradientHighlightButtonSide.RIGHT ? 'left: 0;' : ''}
			border-bottom: 0px solid ${props.theme.palette.brand2};
			${props.selected
        ? `background: linear-gradient(to ${gradientDirection}, ${props.theme.palette.accent1} 0%, ${props.theme.palette.brand1} 60%);`
        : `background: ${props.theme.secondary}`};
			${highlightBoundingSide}: ${props.selected
        ? `calc(100% - ${props.borderSize !== undefined ? `${props.borderSize}px` : `${DEFAULT_BORDER_SIZE}px`})`
        : '100%'};
			transition: ${highlightBoundingSide} 0.2s linear;
		}

		&:hover {
			color: ${props.theme.secondary};
			${props.selected
        ? ''
        : `&:after {
				${highlightBoundingSide}: calc(100% - ${props.borderSize !== undefined ? `${props.borderSize}px` : `${DEFAULT_BORDER_SIZE}px`});
			}`}
			cursor: pointer;
		}

		&:focus {
			outline: none;
		}
	`;
};
const DEFAULT_BORDER_SIZE = 5;
const GradientHighlightButton = styled.button `
	${(props) => GradientHighlightButtonStyles(props)}
`;
export default GradientHighlightButton;
//# sourceMappingURL=GradientHighlightButton.js.map